import React from 'react';
import './home.scss';

export default function Home() {
  return (
    <React.Fragment>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings mb-4'}>
          <div className={'d-flex flex-column align-items-center'}>
            <div className={'logos-container'}>
              <img src='/Logo.png' className="img-fluid mt-1" style={{maxWidth: "200px"}}/>
            </div>
            <h3 className={'mb-2 text-center'}>Welcome to the ezTemplates</h3>
          </div>
        </div>
      </div>
    </React.Fragment>
)}
